import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { showMobileAddToGroupsPanel } from '../../../../Modals/redux/actionCreators';
var mapDispatchToProps = {
    showGroupsPanel: showMobileAddToGroupsPanel,
    showReportModal: showReportModal,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=MoreMenuContent.container.js.map